import React from 'react';
import { useEffect, useState } from 'react';
import { SVBSolutionsSlogan } from '@svb/portal-ui-react-components';
import SolutionTabs from './SolutionTabs';
import Loading from '@svb/api-loading-component/dist/components/index';

function SolutionsCatalog(props) {
  const [loading, setloading] = useState(true);
  const data = props.solutions;

  useEffect(() => {
    setloading(false);
  }, [data]);

  if (loading) {
    return (
      <div className='solutions-loading'>
        <Loading />
      </div>
    );
  }
  const title = data && 'title' in data ? data.title : 'Solutions';
  const description = data && 'description' in data ? data.description : 'Description';

  if (!data) {
    return <span data-testid='empty'></span>;
  }
  return (
    <>
      <SVBSolutionsSlogan
        type='headerBlock'
        title={title}
        description={description}
        bgColor='primary'
        image='/solutions.png'
        extraClasses={'svb-breadcrumb-header-color pt-4 flex-column'}
        breadCrumbs={[
          { breadCrumb: 'Home', link: '/', dataTestId: 'breadcrumb-solution-home' },
          {
            breadCrumb: 'Solutions',
            link: '#',
            dataTestId: 'breadcrumb-solution-details-solutions',
          },
        ]}
      />
      {props.activeKey && props.url && data ? (
        <>
          <SolutionTabs
            activeItem={props.activeKey}
            solutionsURL={props.url}
            content={data}
            isErrorPath={props?.isErrorPath}
          />
        </>
      ) : (
        <>
          {' '}
          <span data-testid='empty'></span>{' '}
        </>
      )}
    </>
  );
}

export default SolutionsCatalog;
